module.exports = __webpack_public_path__ + "static/media/espacios.a3dbc7c7.svg";